module.exports = __webpack_public_path__ + "img/tbt829-1993_1.asm.20218e26.jpg";